export const getRoundedNumber = (number: number | string, digits: number) =>
  +parseFloat(number?.toString()).toFixed(digits);
